__turbopack_context__.v({
  "icon": "Rsnv8q_icon",
  "nonLink": "Rsnv8q_nonLink",
});
